import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  confirmationDialog: {
    "& .MuiDialogTitle-root": {
      maxHeight: 56
    },
    "& .MuiPaper-root": {
      maxWidth: 340,
      [theme.breakpoints.up("sm")]: {
        marginLeft: `calc(${theme.widthTabletDrawer}px + env(safe-area-inset-left))`
      },
      [theme.breakpoints.up("lg")]: {
        marginLeft: `calc(${theme.widthDesktopDrawer}px + env(safe-area-inset-left))`
      }
    },
    "& .MuiDialogContent-root, & .MuiDialogTitle-root": {
      paddingLeft: 20,
      paddingRight: 20
    },
    "& .MuiDialogContent-root": {
      paddingTop: 0,
      paddingBottom: 16
    },
    "& .MuiDialogActions-root": {
      paddingTop: 0,
      paddingLeft: 10,
      paddingRight: 10,
      paddingBottom: 10
    }
  },
  dialogTitleTypography: {
    fontSize: 20,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    lineHeight: "normal",
    color: theme.palette.text.primary
  },
  dialogContentText: {
    fontSize: 14,
    color: theme.palette.text.primary
  },
  button: {
    fontSize: 16,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    "& .MuiButton-label": {
      fontSize: 14
    }
  },
  positive: {
    color: theme.palette.secondary.dark
  },
  negative: {
    color: theme.palette.error.main
  },
  cancel: {
    color: theme.palette.text.secondary
  },
  decisions: {
    flexGrow: 1,
    textAlign: "right"
  }
}));
